import auth0 from 'auth0-js';

import history from '../history.js';

export default class Auth {
	auth0 = new auth0.WebAuth({
		domain: 'noeltrans.auth0.com',
		clientID: process.env.REACT_APP_AUTH_API_KEY,
		redirectUri: `${window.location.origin}/callback`,
    audience: 'https://noeltrans.auth0.com/userinfo',
    responseType: 'token id_token',
    scope: 'openid profile'
	});

	constructor() {
		this.login = this.login.bind(this);
		this.logout = this.logout.bind(this);
		this.handleAuthentication = this.handleAuthentication.bind(this);
		this.isAuthenticated = this.isAuthenticated.bind(this);
		this.getProfile = this.getProfile.bind(this);
	}

	userProfile;

	getAccessToken() {
		const accessToken = localStorage.getItem('access_token');

		if (!accessToken) {
			throw new Error('No Access Token Found');
		}

		return accessToken;
	}

	getProfile(cb) {
		let accessToken = this.getAccessToken();
		this.auth0.client.userInfo(accessToken, (err, profile) => {
			if (profile) {
				this.userProfile = profile;
			}

			cb(err, profile);
		});
	}

	login() {
		this.auth0.authorize();
	}

	handleAuthentication() {
		this.auth0.parseHash((err, authResult) => {
			if (authResult && authResult.accessToken && authResult.idToken) {
				this.setSession(authResult);
				history.replace('/home');
			} else if (err) {
				history.replace('/home');
				console.log(err);
			}
		});
	}

	setSession(authResult) {
		let expiresAt = JSON.stringify((authResult.expiresIn * 1000) + new Date().getTime());
		localStorage.setItem('access_token', authResult.accessToken);
		localStorage.setItem('id_token', authResult.idToken);
		localStorage.setItem('expires_at', expiresAt);

		history.replace('/home');
	}

	logout() {
		localStorage.removeItem('access_token');
		localStorage.removeItem('id_token');
		localStorage.removeItem('expires_at');

		history.replace('/home');
	}

	isAuthenticated() {
		let expiresAt = JSON.parse(localStorage.getItem('expires_at'));

		return new Date().getTime() < expiresAt;
	}
}


// WEBPACK FOOTER //
// ./src/utils/Auth.js